import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter as Router, Routes, Route, Redirect } from "react-router-dom";

import Home from '../app/views/Home/Home';
import Model from '../app/views/Model/Model';
import Talent from '../app/views/Talent/Talent';
import Error from '../app/views/Error/Error';

const AppRoutes = () => {

    return (
        <div className="">
            <Router>
                <Routes>
                    <Route exact path={'/'} element={<Home />} />
                    <Route exact path={'/models/:city/:model'} element={<Model />} />
                    <Route exact path={'/talent'} element={<Talent />} />
                    <Route exact path={'/talent/:city'} element={<Talent />} />
                    <Route exact path={'*'} element={<Error />} />
                </Routes>
            </Router>
        </div>
    )
}

export default AppRoutes;